import React from 'react';
import { getNativeTitle } from '../../utils/getNativeTitle';
import './BilingualTitle.css';

interface BilingualTitleProps {
  title: string;
  titles?: Record<string, string> | null;
  fallback?: string;
  variant?: 'card' | 'header' | 'compact';
  as?: 'h1' | 'h2' | 'h3' | 'span';
  className?: string;
}

export const BilingualTitle: React.FC<BilingualTitleProps> = ({
  title,
  titles,
  fallback,
  variant = 'card',
  as: Tag = 'h3',
  className,
}) => {
  const nativeTitle = getNativeTitle(titles);
  const displayTitle = title || fallback || '';

  return (
    <Tag className={`${className || ''} bilingual-title--${variant}`}>
      <span className="bilingual-title__en">{displayTitle}</span>
      {nativeTitle && (
        <span className="bilingual-title__native">{nativeTitle}</span>
      )}
    </Tag>
  );
};
